import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.283 132.283"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "matrix(1.33333 0 0 -1.33333 0 132.283)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M99.078 49.742C99.078 22.419 76.928.27 49.606.27 22.284.27.135 22.419.135 49.74c0 27.323 22.149 49.472 49.47 49.472 27.324 0 49.473-22.15 49.473-49.471",
        fill: "none",
        stroke: "none",
        strokeMiterlimit: 10
      }), /*#__PURE__*/_jsx("path", {
        d: "M56.329 40.45c-5.433-5.329-12.434-8.297-18.774-7.945l-2.27 6.201 7.406 2.437 1.726-3.899 1.287.48c3.019 1.304 5.846 3.192 8.016 5.32 2.159 2.118 4.232 5.08 5.592 8.071l.557 1.27-3.858 1.76 2.59 7.511 6.18-2.244c.225-6.28-3.03-13.642-8.452-18.962m11.3 20.107s-.047.61-.091.913l-10.544 3.928-4.478-12.976 3.487-1.669c-1.104-2.078-2.695-4.206-4.238-5.72-1.555-1.525-3.547-2.895-5.652-3.962l-1.632 3.536-12.968-4.15 3.938-10.679c.87-.193 2.883-.213 2.883-.213 6.867-.08 14.193 3.19 19.944 8.83 6.295 6.177 9.988 14.784 9.35 22.162",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "m48.364 56.719 2.268 1.367c-.363.609-.461 1.622-.234 2.429.21.75.75 1.516 1.292 1.863l-1.335 2.309a5.642 5.642 0 0 1-2.683-3.405c-.454-1.612-.141-3.25.693-4.563m-2.402-1.529c-1.256 1.976-1.727 4.44-1.044 6.867a8.498 8.498 0 0 0 4.037 5.122l-1.384 2.47a11.324 11.324 0 0 1-5.38-6.825c-.908-3.233-.281-6.515 1.392-9.148z",
        fill: "currentColor"
      })]
    })
  }));
};
export default SvgComponent;